<template>
    <b-overlay :show="loading" rounded="sm">
        <b-card title="Informações Básicas">
            <b-form @submit="submit" @submit.stop.prevent>

                <!-- Field -->
                <b-form-group
                    label="Nome">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.name"
                        :state="hasErrors('name', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="name" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Email">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.email"
                        :state="hasErrors('email', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="email" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Telefone">
                    <!-- Input -->
                    <the-mask
                        type="tel"
                        :mask="['(##) #####-####', '(##) ####-####']"
                        v-model="form.phone"
                        class="form-control"
                    ></the-mask>

                    <!-- Error -->
                    <has-errors :errors="errors" name="phone" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Telegram">
                    <!-- Input -->
                    <b-form-input
                        v-model="form.telegram"
                        placeholder="Ex: https://t.me/meu-perfil"
                        :state="hasErrors('telegram', errors)"
                    ></b-form-input>

                    <!-- Error -->
                    <has-errors :errors="errors" name="telegram" />
                </b-form-group>

                <!-- Field -->
                <b-form-group
                    label="Notificações por Email">

                    <!-- Input -->
                    <b-form-checkbox
                        v-model="form.notify"
                        name="notify"
                        switch>

                            <span v-if="form.notify">
                                <b>Quero receber notificações</b> quando algum aluno enviar redação para a plataforma.
                            </span>

                            <span v-else>
                                <b>Não quero receber notificações</b> quando algum aluno enviar redação para a plataforma.
                            </span>

                    </b-form-checkbox>

                    <!-- Error -->
                    <has-errors :errors="errors" name="notify" />
                </b-form-group>

                <!-- Submit -->
                <b-button type="submit" variant="primary" :disable="loading">
                    Atualizar
                </b-button>

            </b-form>
        </b-card>
    </b-overlay>
</template>

<script>
export default {
    props: ['endpointShow', 'endpointUpdate'],
    data() {
        return {
            loading: false,
            errors: {},
            form: {
                name: null,
                email: null,
                phone: null,
                telegram: null,
                notify: null
            }
        }
    },
    created() {
        this.load();
    },
    methods: {

        load() {
            this.loading = true;
            axios.get(this.endpointShow)
                .then((result) => {
                    const response = result.data.data
                    this.form.name = response.teacher.name
                    this.form.email = response.teacher.email
                    this.form.phone = response.teacher.phone
                    this.form.telegram = response.teacher.telegram
                    this.form.notify = response.teacher.notify
                })
                .finally(() => this.loading = false)
        },

        submit() {
            this.loading = true;
            axios.put(this.endpointUpdate, this.form)
                .then((result) => {
                    // Redirect
                    this.redirectIfNeed(result)

                    // Clear Errors
                    this.errors = {}
                })
                .catch((errors) => {
                    // Check Errors
                    this.errors = this.setErrors(errors)
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
